import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetQueueRequestsCount } from 'domain/usecases';
import { RemoteGetQueueRequestsCount } from 'data/usecases/queue/remote-get-queue-requests-count';

export const makeRemoteGetQueueRequestsCount = (): GetQueueRequestsCount => {
  return new RemoteGetQueueRequestsCount(makeApiUrl('/queue/requests/count'), makeAuthorizeHttpClientDecorator());
};
